// Каталог сервиса ассетов (GET /api/v1/assets, публичный): медиа уровней и
// сюжет-роликов живёт на S3/CDN. Плеер получает players[].baseUrl своего
// playerType через LevelConfig.media (PlayScreen), ролики строятся от
// mediaBaseUrl (meta/story.ts). Вынесен из PlayScreen: каталог нужен и
// коллекции (модал пересмотра роликов).

import { routes } from '@/api/routes';

export interface AssetsCatalogDto {
  version: string; mediaBaseUrl: string;
  players: { playerType: string; baseUrl: string }[];
}

// каталог — один на сессию: кэш в модульной промисе, чтобы не дёргать сервис на
// каждый уровень; фейл НЕ кэшируем — «ещё раз»/следующий уровень запросят снова
let assetsCatalog: Promise<AssetsCatalogDto> | null = null;

export function loadAssetsCatalog(): Promise<AssetsCatalogDto> {
  if (!assetsCatalog) {
    // эндпоинт публичный: обычный fetch, без Authorization
    assetsCatalog = fetch(routes.assets).then(async (resp) => {
      if (!resp.ok) throw new Error(`assets ${resp.status}`);
      return (await resp.json()) as AssetsCatalogDto;
    });
    assetsCatalog.catch(() => { assetsCatalog = null; });
  }
  return assetsCatalog;
}

/** Сброс кэша каталога (тесты — ср. resetSave/resetPrefs). */
export function resetAssetsCatalog(): void { assetsCatalog = null; }
